import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconLock, IconPalette, IconLanguage, IconAdjustments, IconServer, IconQrcode } from "@tabler/icons-react";
import { LangConstant } from "const";
import { PageTitle } from "components";
import { ChangePasswordForm, ChangeLanguageForm, ChangeMode, ServerInformation, ChangeThemeForm } from "./components";
import QRServerSection from "./components/QRServerSection";
import { useRole } from "hooks";

const TABS = {
  PASSWORD: "password",
  THEME: "theme",
  LANGUAGE: "language",
  MODE: "mode",
  SERVER: "server",
  QR: "qr",
};

const Settings = () => {
  const { t: getLabel } = useTranslation([LangConstant.NS_COMMON, LangConstant.NS_LOGIN]);
  const { isServiceAdmin } = useRole();
  const titleObjectContent = getLabel(LangConstant.OBJ_SIDEBAR_TITLE, { returnObjects: true });

  const [activeTab, setActiveTab] = useState(TABS.PASSWORD);

  const menuItems = [
    { key: TABS.PASSWORD, icon: IconLock, label: getLabel("login:L_PASSWORD") },
    { key: TABS.THEME, icon: IconPalette, label: getLabel("TXT_SETTINGS_THEME") },
    ...(!isServiceAdmin
      ? [
          { key: TABS.LANGUAGE, icon: IconLanguage, label: getLabel(LangConstant.L_LANGUAGE) },
          { key: TABS.MODE, icon: IconAdjustments, label: getLabel(LangConstant.TXT_MODE) },
          { key: TABS.SERVER, icon: IconServer, label: getLabel("TXT_SETTINGS_SERVER") },
          { key: TABS.QR, icon: IconQrcode, label: getLabel(LangConstant.TXT_QR_SERVER) },
        ]
      : []),
  ];

  const renderContent = () => {
    switch (activeTab) {
      case TABS.PASSWORD:
        return <ChangePasswordForm />;
      case TABS.THEME:
        return <ChangeThemeForm />;
      case TABS.LANGUAGE:
        return <ChangeLanguageForm />;
      case TABS.MODE:
        return <ChangeMode />;
      case TABS.SERVER:
        return <ServerInformation />;
      case TABS.QR:
        return <QRServerSection />;
      default:
        return <ChangePasswordForm />;
    }
  };

  return (
    <Fragment>
      <PageTitle>{titleObjectContent.settings}</PageTitle>
      <div className="card">
        <div className="row g-0">
          {/* Sidebar menu */}
          <div className="col-3 d-flex flex-column border-end" style={{ minHeight: "500px" }}>
            <div className="list-group list-group-flush list-group-hoverable">
              {menuItems.map(item => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.key}
                    className={`list-group-item list-group-item-action d-flex align-items-center gap-2 ${activeTab === item.key ? "active" : ""}`}
                    onClick={() => setActiveTab(item.key)}
                  >
                    <Icon size={18} />
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Content area */}
          <div className="col-9">
            <div className="card-body">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Settings;
